<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader :title="`${nameLabel} Content-Details-View`"></PageHeader>
      <el-form class="filter-wrapper" label-width="60px">
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Role" prop="role">
            <el-select
              v-model="form.role"
              placeholder="Please select Role"
              filterable
              @change="roleChange"
            >
              <el-option
                v-for="(item, idx) in roleOptions"
                :key="idx"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Leader" prop="taId">
            <el-select
              v-model="form.taId"
              placeholder="Please select Leader"
              filterable
              @change="taChange"
            >
              <el-option
                v-for="(item, idx) in taOptions"
                :key="idx"
                :label="item.TAName"
                :value="item.TAID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Team" label-width="55px">
            <el-select
              v-model="form.teamId"
              placeholder="Please select Team"
              filterable
            >
              <el-option
                v-for="(item, idx) in teamOptions"
                :key="idx"
                :label="item.TeamName"
                :value="item.TeamID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Year">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option
                v-for="item in yearsOptions"
                :key="item.Year"
                :label="item.Year"
                :value="item.Year"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Month">
            <el-select
              class="month-select"
              ref="monthSelect"
              v-model="form.month"
              placeholder="Please select month"
              multiple
              v-multiple-tip
              @change="monthSelectChange"
            >
              <el-option
                v-for="item in monthOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Type" prop="type">
            <el-select v-model="form.type" placeholder="Please select type">
              <el-option label="All" value="" />
              <el-option
                label="Content Push / Meeting Push"
                value="ContentMeetingPush"
              />
              <el-option label="Quick Push" value="QuickPush" />
            </el-select>
          </el-form-item>
        </el-col>
        <div class="query-action">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getTableData()"
            :disabled="queryable"
          >
            Query
          </el-button>
          <el-button
            type="primary"
            icon="iconfont icon-export"
            @click="getTableData(true)"
            :disabled="exportable"
            :loading="exporting"
          >
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
      >
        <el-table-column prop="Department" label="Title" width="125" />
        <el-table-column prop="NoOfPush" label="No. Of Push" min-width="105" />
        <el-table-column prop="NoOfHits" label="No. Of Hits" min-width="115" />
        <el-table-column
          prop="NoOfComments"
          label="No. Of Comments"
          min-width="140"
        />
        <el-table-column
          min-width="115"
          prop="Interactions"
          label="Interaction"
        />
        <el-table-column
          min-width="150"
          prop="AvgPageView"
          label="Avg. Duration(s)"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import downloadjs from "downloadjs";
import { getDataZoomOptions } from "../../utils/echarts";
import labelMixin from "@/mixins/label-mixin";
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "SE-Activity-Department-View",
  mixins: [labelMixin],
  data() {
    return {
      tableLoading: false,
      tableData: [],
      exporting: false,
      form: {
        role: "",
        taId: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        type: "",
      },
      roleList: [],
      taList: [],
      teamList: [],
      otherList: null,
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      queryable: true,
      exportable: true,
    };
  },
  created() {
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
    this.getData();
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    filterSpan() {
      return this.role === 1 ? 6 : 5;
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    roleOptions() {
      return [{ value: "", name: "All" }].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
        this.taList.filter(({ RoleName }) => {
          return this.form.role
            ? this.form.role === "MSL"
              ? RoleName === "TALead"
              : RoleName.indexOf(this.form.role) > -1
            : true;
        })
      );
    },
    teamOptions() {
      let options = this.teamList.filter(({ TAID, RoleName }) => {
        return this.form.taId
          ? this.form.taId === TAID
          : RoleName.indexOf(this.form.role) > -1 ||
              (this.form.role === "MSL" &&
                (RoleName === "TALead" || RoleName === "Supervisor"));
      });
      return this.role === 1 || this.role === 4
        ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options)
        : options;
    },
  },
  mounted() {},
  methods: {
    getDataZoomOptions,
    roleChange() {
      this.form.taId = "";
      this.form.teamId = "";
    },
    taChange() {
      this.form.teamId = "";
    },
    monthSelectChange(value) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form.month = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form.month = [""];
      }
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
          mlName: this.mlName,
        });
      }
      this.axios
        .get(`analytics/seDepartment`, {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.tableData = data;
              this.tableLoading = false;
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
        this.axios.get(`analytics/otherList`),
        this.axios.get(`analytics/roleList`),
      ]).then((res) => {
        this.getTAList(res[0]);
        this.getTeamList(res[1]);
        this.getOtherList(res[2]);
        this.getRoleList(res[3]);
        this.getTableData();
        this.queryable = false;
        this.exportable = false;
      });
    },
    getRoleList({ code, data, msg }) {
      if (200 === code) {
        this.roleList = data;
        if (
          this.role === RoleCode.Supervisor ||
          this.role === RoleCode.TALead
        ) {
          const { value } = data[0] || { value: "" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(
            ({ value }) => roleName.indexOf(value) > -1
          ) || { value: "" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        this.taList = data;
        if (this.role === 4) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (
          this.role == RoleCode.Supervisor ||
          this.role == RoleCode.CRPLeader ||
          this.role == RoleCode.CVEOLeader ||
          this.role == RoleCode.SciComLeader ||
          this.role == RoleCode.ClinTransLeader
        ) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
      } else {
        this.$message.error(msg);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;
  .el-form-item {
    margin-bottom: 10px !important;
    .el-select {
      width: 100%;
    }
  }
  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}
</style>
